module.exports = __webpack_public_path__ + "img/x2.c65b1f18.jpg";